import { render, staticRenderFns } from "./ForgetPassModal.vue?vue&type=template&id=8ae99d38&"
import script from "./ForgetPassModal.vue?vue&type=script&lang=js&"
export * from "./ForgetPassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports